import { useState, useEffect, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  Button,
  Drawer,
  TextField,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseAdvertisments } from "./UseAdvertisments";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import DeleteRow from "../../components/DeleteRow";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import { useSnackbar } from "notistack";

export default function DescriptionsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const {
    addAdvertismentDescription,
    deleteAdvertismentDescription,
    getAdvertismentByID,
  } = UseAdvertisments();
  const { isSmall } = useBreakpoints();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const addTitle = useRef(null);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [open, setOpen] = useState(false);
  const [descriptionRes, setDescriptionRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [descriptionState, setDescriptionState] = useState({
    advertismentID: undefined,
    description: undefined,
    rowIndex: undefined,
    cost: undefined,
  });

  useEffect(() => {
    if (props.advertismentID) {
      getAdvertismentByID(props.advertismentID, (resault) => {
        setDescriptionRes(resault.descriptions);
      });
    }
  }, [props.advertismentID]);

  useEffect(() => {
    if (descriptionRes) {
      var lastrowIndex = Math.max.apply(
        Math,
        descriptionRes &&
          descriptionRes.map(function (o) {
            if (o) {
              return o.rowIndex;
            } else {
              return 1;
            }
          })
      );
      setDescriptionState({
        ...descriptionState,
        advertismentID: props.advertismentID,
        rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
      });
    }
  }, [descriptionRes]);

  const newFunc = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (open) {
      addTitle.current.focus();
    }
  }, [open]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "rowIndex",
      headerName: "ردیف",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "description",
      headerName: "عنوان",
      width: 500,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.description}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 100,
      align: "center",
      headerAlign: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: cellValues.row.description,
                  id: cellValues.row.id,
                });
              }}
            >
              <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      {descriptionRes ? (
        <DataGrid
          disableVirtualization
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={descriptionRes}
          page={pageState.page - 1}
          pageSize={20}
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={
            descriptionRes && descriptionRes.length ? descriptionRes.length : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              rowCount:
                descriptionRes && descriptionRes.length
                  ? descriptionRes.length
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "ID",
                  sort: "Asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"توضیح"}
        callback={() => {
          setProgress(true);
          deleteAdvertismentDescription(deleteState.id, () => {
            getAdvertismentByID(props.advertismentID, (resault) => {
              setDescriptionRes(resault.descriptions);
            });
          });
        }}
      ></DeleteRow>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
          setDescriptionState({
            ...descriptionState,
            description: "",
            cost: undefined,
          });
        }}
        sx={{
          "&  .MuiDrawer-paper": {
            height: "40%",
            width: isSmall ? "90%" : "30%",
            mx: "auto",
            borderRadius: 3,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: 4,
            m: 3,
          }}
        >
          <TextField
            color="secondary"
            id="outlined-multiline-static"
            label="متن توضیح"
            autoFocus
            multiline
            rows={4}
            value={
              descriptionState.description ? descriptionState.description : ""
            }
            inputRef={addTitle}
            onChange={(event) => {
              setDescriptionState({
                ...descriptionState,
                description: event.target.value,
              });
            }}
            fullWidth
          />
          <Box sx={{ mx: "auto", mb: 3 }}>
            <Button
              variant="contained"
              sx={{ width: "100px", mr: 2 }}
              color="secondary"
              onClick={() => {
                if (!descriptionState.description) {
                  enqueueSnackbar("لطفا متن توضیح را وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                  });
                  return;
                }
                setProgress(true);
                addAdvertismentDescription(descriptionState, () => {
                  getAdvertismentByID(props.advertismentID, (resault) => {
                    setOpen(false);
                    setDescriptionRes(resault.descriptions);
                    setDescriptionState({
                      ...descriptionState,
                      description: "",
                      cost: undefined,
                    });
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              sx={{ width: "100px" }}
              color="secondary"
              onClick={() => {
                setDescriptionState({
                  ...descriptionState,
                  description: "",
                  cost: undefined,
                });
                setOpen(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}
